import { createFileRoute } from "@tanstack/react-router";
import { IssuesTable } from "#app/components/issues/issues-table";

/** `/team/$teamId/list` — the team's issue list across its workflows. */
function TeamListRoute() {
  const { teamId } = Route.useParams();
  return <IssuesTable scope={{ kind: "team", teamId }} />;
}

export const Route = createFileRoute("/(app)/$workspace/team/$teamId/list")({
  component: TeamListRoute,
});
